export const mockTeamData = {
  _id: "000000000000000000000001",
  email: "dev@getredo.com",
  team: {
    widget: { uri: "/pages/returns-exchanges" },
    fulfillmentService: null,
    _id: "000000000000000000000002",
    name: "[Dev] Redo",
    billingFailure: "restrict",
    storeUrl: "redo-dev.myshopify.com",
    email: "dev@getredo.com",
    adminName: "Redo Developer",
    adminPhone: null,
    industryCategory: {
      redoAssignedCategories: [],
      autoAssignedCategories: [],
      allCategoriesIncludingTransitiveCategories: [],
    },
    users: [
      {
        roles: ["admin"],
        user: {
          _id: "000000000000000000000003",
          name: "Redo Developer",
          firstName: "Redo",
          lastName: "Developer",
          email: "dev@getredo.com",
          roles: ["admin"],
          notifications: {
            mentionedInConversation: {
              desktop: false,
              email: true,
              push: true,
            },
            assignedToConversation: { desktop: false, email: true, push: true },
            newMessageInAssignedConversation: {
              desktop: true,
              email: false,
              push: true,
            },
            newMessageInUnassignedConversation: {
              desktop: true,
              email: false,
              push: false,
            },
            playSoundOnDesktopNotification: true,
            supportNotificationSettings: {},
          },
          usePersonalSignature: false,
          images: [],
          customViewOrdering: [],
          createdAt: "2024-10-21T22:11:28.866Z",
          updatedAt: "2026-03-05T21:50:54.286Z",
          __v: 1,
          team: "000000000000000000000002",
          emailedOnDisconnect: false,
          viewFolders: [],
          managedUserRoles: ["admin"],
          userRoles: [],
          isDeleted: false,
          isRedoEmployee: true,
        },
        email: "dev@getredo.com",
        _id: "000000000000000000000004",
        createdAt: "2024-10-21T22:11:28.913Z",
        updatedAt: "2026-03-04T17:40:36.776Z",
      },
    ],
    automation: {
      returnOrderTags: { onRefund: [], onStoreCredit: [] },
      storeCreditExpiration: { enabled: false, days: 60 },
      enable: true,
      returnProcessing: {
        exchanges: "delivered",
        exchanges_delay: 0,
        refunds: "delivered",
        refunds_delay: 0,
        store_credit: "delivered",
        store_credit_delay: 0,
      },
      claimProcessing: {
        exchanges: "delivered",
        exchanges_delay: 0,
        refunds: "delivered",
        refunds_delay: 0,
        store_credit: "delivered",
        store_credit_delay: 0,
      },
      fulfill_redo_item: "partial",
      giftCardRecipient: "recipient",
      coverageBillingTrigger: "order_creation",
    },
    portal: {
      font_family: "Quicksand",
      title_font_family: "",
      body_font_family: "",
      custom_css: "",
      new_custom_css: "",
      font_weight: 300,
      button_color: "#000000",
      accent_color: "#633CFE",
      accent_background_color: "#EFECFF",
      home_text_color: "#000000",
      enable_alert: false,
      notification: "",
      returnButtonText: "",
      registerButtonText: "",
      claimButtonText: "",
      standard_exchange_text: "",
      hideDiscountCodes: false,
      hideSuggestedProducts: false,
      instant_exchange_text: "",
      custom_payment_placeholder_color: null,
      backorderShowDate: true,
      privacy_link: "",
      background_url: null,
      favicon_url: null,
      logo_url: null,
      colors: ["#000000", "#85e5de", "#e43b4e", "#162e42", "#ffffff"],
      injection_text_color: "#000000",
      domain: "redo-dev.myshopify.com",
      pathPrefix: "/apps/redo",
      collapseVariantThreshold: 20,
      useBetaPackagePickupModal: false,
      socialLoginOptions: ["google"],
    },
    settings: {
      commentsold: {
        sendDropShipperEmail: true,
        useShopifyStorefront: false,
        recProductExclusions: { variantIds: [], parentIds: [], tags: [] },
      },
      returnAdjustment: { positiveName: "bonus", negativeName: "fee" },
      exchanges: {
        orderName: {
          prefix: "",
          suffix: "-EXC",
          orderNamesByReturnType: [],
          useShopifyGeneratedName: false,
          duplicateOrderNumberFormat: " ({n})",
        },
        notes: {
          includeDate: false,
          includeExistingNote: true,
          addNoteToOriginalOrders: false,
          disabled: false,
        },
        selection: "return_app",
        shopSite: { navigationMode: "same_tab" },
        shopSiteUseCartDiscounts: false,
        shouldStripHash: false,
        suffix: null,
        outOfStockPolicy: "store_credit",
        excessExchangeValue: "store_credit",
        usePreDiscountPrice: false,
        outOfStockAdvanced: "cancel",
        allowInstant: false,
        instantExchangeOnly: false,
        instantHoldAmount: "one_dollar",
        instantExpirationDays: 7,
        advancedExchanges: "all",
        excludeProductTags: [],
        recreateExpiredDiscounts: false,
        recreateAutomaticDiscountsAsCodes: false,
        blockDiscountsOnExchanges: false,
        returnDiscountCodeExpirationDays: 30,
        reapplyDiscountAmount: false,
        enableOnHoldOrders: false,
        onHoldOrdersOnUpsellOnly: false,
        differentPricedVariantExchanges: false,
        excludeDifferentPriceVariants: false,
        variantExchangeProductTags: [],
        createLabelOnDraftOrderComplete: false,
        instantExchangeAutoRefundIfExpired: false,
        nonZeroValueExchange: false,
        nonZeroValueExchangeStrategy: "none",
        exchangeOptionsPreviewShowOriginalPrice: false,
        excludedItemProperties: [],
        defaultPosRestock: true,
        applyOriginalOrderDiscounts: ["variant", "advanced"],
        applyAutomaticDiscounts: ["variant", "advanced"],
        allowCustomerDiscountCodes: false,
        exchangeShippingRateTables: [],
        addAdditionalExchangeTags: false,
        shouldRemoveHoldTagWhenRelease: false,
        recreateParentChildBundlesOnExchanges: false,
        variantPickerType: "auto-select",
        exchangeBonusUpsellPageEnabled: false,
        nonInstantExchangeOrderProvision: "all-products-processed",
        separateQuantityForExchangeProducts: true,
        shopifyDeferReturnItemProcessing: false,
      },
      inventory: {
        ignoreInventory: false,
        ignoreInventoryForReturnTypes: [],
        minimum_stock: 1,
        restock: true,
        restockDamaged: true,
        restockShopifyRefunds: false,
        allowRestockBeforeProcess: false,
        disposeShopifyReverseFulfillmentOnRestock: false,
        skipEcommerceProviderRestock: false,
      },
      labelExpiration: {
        shouldReopenReturnWhenLabelUsed: false,
        reopenReturnAfterDays: 10,
        days: 28,
        reminderEmails: false,
        expirationEmails: false,
        reminderEmailDays: [],
        strategy: "return",
        compensationMethodsToRemind: ["refund", "store_credit", "exchange"],
        flagReturnWhenReopened: true,
      },
      enabled: true,
      countries: ["US"],
      countriesPackageProtection: ["US"],
      returns: {
        permissions: {
          allowedCompensationMethods: ["credit", "exchange", "refund"],
          allowEditReturn: true,
          allowEditFeesAndBonuses: true,
          allowEditGreenReturns: true,
        },
        enabled: true,
        enableCustomerPortal: true,
        buyYourOwnLabel: false,
        allowMultiOrderReturns: false,
        multiOrderReturnLimit: 0,
        agentReviewEnabled: true,
        agentChatEnabled: true,
        enableMerchantReturnFlow: true,
        enableGiftReceipts: true,
      },
      support: {
        enabled: true,
        closeAction: "next",
        defaultSendAction: "send",
        useInProgressStatus: false,
        keepAssigneeOnTicketReopen: true,
        tags: [],
        ticketAssignment: "manual",
        ai: {
          enabled: true,
          copilotEnabled: true,
          autoGenerateResponses: true,
          autopilotEnabled: false,
        },
        sms: { enabled: false },
        voice: { enabled: false },
      },
      orderTracking: {
        enabled: true,
        v2: { enabled: true, dispatchEnabled: true },
        createTrackers: true,
        smsEnabled: true,
      },
      packageProtection: { enabled: false, coverage: false },
      reviews: { enabled: true },
      marketing: {
        campaigns: { enabled: true },
        enabled: true,
        textsEnabled: true,
        loyalty: { enabled: true },
      },
      recover: { enabled: true, billing: { enabled: false } },
      customerAccounts: { enabled: true, webPixelEnabled: true },
      concierge: { enabled: false },
      outboundLabels: { newOmsEnabled: true },
      customerPortalVersion: "v4.0",
      warranties: { enabled: false },
      returnsAiExchange: {
        enabled: true,
        enableBilling: false,
        renewOnPeriodEnd: false,
        period: "month",
        periodFeeInCents: 0,
        usageFee: 3.5,
        usageFeePercent: 0,
        billingFeeType: "flat",
        billingType: "shopify",
      },
      shopifySubscription: [],
      shopifySubscriptionMetadata: { isAtShopifyBillingCap: false },
      brandKit: {
        colors: { background: "#ffffff", accent: "#000000" },
        font: {
          fontFamily: "Arial",
          headerFontFamily: "Arial",
          bodyFontFamily: "Arial",
          hierarchy: {
            h1: { fontSizePx: 48, fontWeight: "bold" },
            h2: { fontSizePx: 36, fontWeight: "semibold" },
            h3: { fontSizePx: 30, fontWeight: "regular" },
            body: { fontSizePx: 16, fontWeight: "regular" },
            subtext: { fontSizePx: 14, fontWeight: "regular" },
          },
        },
        socialLinks: {},
        inputs: {
          backgroundColor: "#ffffff",
          errorColor: "#ff0000",
          textColor: "#000000",
          border: {
            cornerRadiusPx: 8,
            stroke: { color: "#000000", weightPx: 1 },
          },
          paddingPx: 8,
          fontReference: "body",
        },
        buttons: {
          primary: {
            backgroundColor: "#000000",
            textColor: "#ffffff",
            border: {
              cornerRadiusPx: 8,
              stroke: { color: "#000000", weightPx: 1 },
            },
            paddingPx: 8,
            fontReference: "body",
          },
          secondary: {
            backgroundColor: "#ffffff",
            textColor: "#000000",
            border: {
              cornerRadiusPx: 8,
              stroke: { color: "#000000", weightPx: 1 },
            },
            paddingPx: 8,
            fontReference: "body",
          },
          tertiary: {
            backgroundColor: undefined,
            textColor: "#000000",
            border: {
              cornerRadiusPx: 8,
              stroke: { color: "#000000", weightPx: 0 },
            },
            paddingPx: 8,
            fontReference: "body",
          },
        },
        images: {
          logoUrl: "",
          faviconUrl: "",
          bannerUrl: "",
          logoBannerUrl: "",
        },
      },
    },
    billingMethod: "fake",
    images: [],
    widget_slug: "yx04y8a4sec4ztl",
    notification_email: "dev@getredo.com",
    customer_email: "dev@getredo.com",
    createdAt: "2024-10-21T22:11:28.913Z",
    updatedAt: "2026-03-24T04:54:02.420Z",
    address: {
      name: "[Dev] Redo",
      street1: "14761 Future Way",
      street2: "Suite 400",
      city: "Draper",
      state: "Utah",
      zip: "84020",
      country: "US",
      country_name: "United States",
      phone: null,
    },
    _shopify: {
      id: 90_707_296_563,
      name: "[Dev] Redo",
      email: "dev@getredo.com",
      domain: "redo-dev.myshopify.com",
      province: "Utah",
      country: "US",
      address1: "14761 Future Way",
      zip: "84020",
      city: "Draper",
      primary_locale: "en",
      currency: "USD",
      money_format: "${{amount}}",
      weight_unit: "lb",
      plan_display_name: "Developer Preview",
      plan_name: "partner_test",
      myshopify_domain: "redo-dev.myshopify.com",
      multi_location_enabled: true,
    },
    domain: "redo-dev.myshopify.com",
    teamType: "store",
    fulfillsFor: [],
    platform: "shopify",
    accessScope: [],
    redoInternalProducts: {
      status: {},
      lastSyncedAt: "2026-03-24T00:47:21.423Z",
    },
    onboarding: {
      _id: "000000000000000000000005",
      team: "000000000000000000000002",
      finished: true,
      processing: false,
      confirmed: true,
      tcConfirmed: true,
    },
  },
  __v: 1,
  createdAt: "2025-03-10T22:58:04.014Z",
  customViewOrdering: [],
  emailedOnDisconnect: false,
  firstName: "Redo",
  images: [],
  lastName: "Engineer",
  name: "Redo Engineer",
  notifications: {
    mentionedInConversation: { desktop: false, email: true, push: true },
    assignedToConversation: { desktop: false, email: true, push: true },
    newMessageInAssignedConversation: {
      desktop: true,
      email: false,
      push: true,
    },
    newMessageInUnassignedConversation: {
      desktop: true,
      email: false,
      push: false,
    },
    playSoundOnDesktopNotification: true,
  },
  roles: ["admin"],
  updatedAt: "2026-03-24T04:53:58.417Z",
  usePersonalSignature: false,
  viewFolders: [],
  managedUserRoles: ["admin"],
  userRoles: [],
  isRedoEmployee: true,
  isDeleted: false,
  featureFlags: {
    "merchant-onboarding": "guided",
    "merchant-dashboard-walkthroughs": true,
    "merchant-dashboard-onboarding-products": true,
    "marketing-segment-email-domain-filter": true,
  },
  shopify: {
    exchangeOrderStrategy: "order",
    checkoutOutboundRatesEnabled: false,
    hasShopifyPlus: false,
    planDisplayName: "Developer Preview",
  },
  platform: "shopify",
};

export const mockUserData = {
  _id: "000000000000000000000001",
  email: "dev@getredo.com",
  firstName: "Redo",
  lastName: "Engineer",
  name: "Redo Engineer",
  createdAt: "2025-03-10T22:58:04.014Z",
  updatedAt: "2026-03-24T04:53:58.417Z",
  roles: ["admin"],
  images: [],
  team: "000000000000000000000002",
  notifications: {
    mentionedInConversation: { desktop: false, email: true, push: true },
    assignedToConversation: { desktop: false, email: true, push: true },
    newMessageInAssignedConversation: {
      desktop: true,
      email: false,
      push: true,
    },
    newMessageInUnassignedConversation: {
      desktop: true,
      email: false,
      push: false,
    },
    playSoundOnDesktopNotification: true,
  },
  usePersonalSignature: false,
  viewFolders: [],
  customViewOrdering: [],
  managedUserRoles: ["admin"],
  userRoles: [],
  isRedoEmployee: true,
  isDeleted: false,
};

export const mockOnboardingData = {
  _id: "000000000000000000000005",
  team: "000000000000000000000002",
  finished: true,
  processing: false,
  confirmed: true,
  tcConfirmed: true,
};
